import React from "react";

type Props = {
  className?: string;
};
export const CardsIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 20 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41781 2.4495L17.1111 4.77887L13.7465 17.3359L13 17.1359V19.2064L13.2289 19.2678C14.2958 19.5536 15.3925 18.9205 15.6783 17.8535L19.043 5.29651C19.3289 4.22958 18.6957 3.1329 17.6288 2.84702L8.93545 0.51765C7.86852 0.231766 6.77184 0.864931 6.48596 1.93186L5.76154 4.63544H2C0.895431 4.63544 0 5.53087 0 6.63544V19.6354C0 20.74 0.89543 21.6354 2 21.6354H11C12.1046 21.6354 13 20.74 13 19.6354V6.63544C13 5.53087 12.1046 4.63544 11 4.63544H7.83209L8.41781 2.4495ZM2 6.63544H11V19.6354H2L2 6.63544Z"
      />
    </svg>
  );
};
